// src/pages/Store/components/desktop/DesktopRail.tsx
import React, { useEffect, useRef, useState } from "react";
import { IGroup } from "../../../../classes/interfaces";
import Icon from "../../../../components/ui/Icon";
import { resolveGroupIcon } from "../../../../helpers/groupIcon.helper";
import { Wrap, Inner, ChipsRow, Chip, ChipIconBadge, RailArrow } from "./DesktopRail.styles";

interface DesktopRailProps {
  groups: IGroup[];
  activeId: string | null;
  onPick: (groupId: string) => void;
}

export default function DesktopRail({ groups, activeId, onPick }: DesktopRailProps) {
  const scrollerRef = useRef<HTMLDivElement>(null);
  const [edges, setEdges] = useState({ left: false, right: false });

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return;

    function updateEdges() {
      if (!el) return;
      setEdges({
        left: el.scrollLeft > 4,
        right: el.scrollLeft + el.clientWidth < el.scrollWidth - 4,
      });
    }

    updateEdges();
    el.addEventListener("scroll", updateEdges);
    window.addEventListener("resize", updateEdges);
    return () => {
      el.removeEventListener("scroll", updateEdges);
      window.removeEventListener("resize", updateEdges);
    };
  }, [groups]);

  function nudge(direction: -1 | 1) {
    scrollerRef.current?.scrollBy({ left: direction * 220, behavior: "smooth" });
  }

  return (
    <Wrap>
      <Inner>
        <ChipsRow ref={scrollerRef}>
          {groups.map((group) => (
            <Chip
              key={group.id}
              $active={activeId === group.id}
              aria-current={activeId === group.id ? "true" : undefined}
              type="button"
              onClick={() => onPick(group.id)}
            >
              <ChipIconBadge $active={activeId === group.id}>
                <Icon name={resolveGroupIcon(group)} size={17} strokeWidth={2} />
              </ChipIconBadge>
              {group.name}
            </Chip>
          ))}
        </ChipsRow>
        {edges.left && (
          <RailArrow $side="left" type="button" aria-label="Rolar categorias para a esquerda" onClick={() => nudge(-1)}>
            <Icon name="back" size={16} />
          </RailArrow>
        )}
        {edges.right && (
          <RailArrow $side="right" type="button" aria-label="Rolar categorias para a direita" onClick={() => nudge(1)}>
            <Icon name="chevron" size={16} />
          </RailArrow>
        )}
      </Inner>
    </Wrap>
  );
}
